// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__mGZc0","header":"Messages_header__2F-d3"};